import { Fragment, useEffect, useState, useRef } from 'react'
import PageLayout from '../Layouts/PageLayout'
import Spinner from '../FieldComponets/Spinner';
import { useDispatch, useSelector } from 'react-redux';
import { PAGES } from '../../Constants/CommonConstants';
import { MaterialReactTable } from 'material-react-table'
import { LinkButtons } from '../FieldComponets/LinkButtons';
import { paginationQuery, handleSearch } from '../../utils/GlobalHelper';
import type { ColumnFiltersState, PaginationState } from '@tanstack/react-table';
import React from 'react';
import { getDate } from '../../utils/Helper';
import { ContactlistGetAction, ContactStatusGetAction } from '../../Redux/Action/ContactAction';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getDateFormatData } from "../../utils/Helper";
import { toast } from 'react-toastify';

function Contact() {

  const dispatch = useDispatch<any>();

  const Contact_Us_Get = useSelector((state: any) => state.Contact_Us_GetState);
  const Contact_Us_status = useSelector((state: any) => state.ContactStatusState);




  const [data, setData] = useState<any>([]);
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
  const [sorting, setSorting] = useState<any>(['ASC']);
  const [open, setOpen] = useState(false)
  const [replymessage, setReplymessage] = useState('')
  const [error, setError] = useState('')
  const [onedata, setOnedata] = useState<any>({})

  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: PAGES?.pageIndex,
    pageSize: PAGES?.pageSize
  });
  const [searchValue, setSearchValue] = useState('');
  const [rowCount, setRowCount] = useState(0);

  const [className, setClassName] = useState('');
  const formRef = useRef<HTMLFormElement>(null);
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [openSerach, setOpenSerach] = useState(false)
  const [serachstatus, setSerachstatus] = useState<any>('')

  const handleFilterValue = (e: any) => {
    const { name, value } = e.target;
    setSerachstatus((prevStatus: any) => ({ ...prevStatus, [name]: value, }));
  };

  const handleOpen = (Id: any) => {
    setOpen(true)
    setOnedata(Id)
  }
  const showPopu =()=>{
    toast.error("You have already replied to this contact.")
  }
  // Table Coulmns
  const columns: any = [
    {
      accessorKey: 'S.NO',
      header: 'S.NO',
      accessorFn: (row: Object, index: number) => {
        const currentPage = pagination.pageIndex + 1 || 1; // Assuming current page number, default to 1 if not provided
        const itemsPerPage = pagination.pageSize || 10; // Assuming items per page, default to 10 if not provided
        const startIndex = (currentPage - 1) * itemsPerPage;
        const serialNumber = startIndex + index + 1;
        return serialNumber;
      },
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
      size: 50
    },
    {
      accessorKey: 'name',
      header: 'Name',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'email',
      header: 'Email',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'user_type',
      header: 'User Type',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'number',
      header: 'Number',
      accessorFn: (row: { phone_number: any; phone_country_code:any }) => row?.phone_number ? <p>{row?.phone_country_code} {row?.phone_number}</p> : <p>---</p>,
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'status',
      header: 'Status',
      accessorFn: (row: { is_reply: any; }) => row.is_reply == 1 ? <p>Replied</p> : <p>Not replied</p>,
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
      size: 100
    },
    {
      accessorKey: 'created_at',
      header: 'Created At',
      accessorFn: (row: { created_at: any; }) => getDate(row.created_at),
      // dateSetting: { locale: "en-GB" },
      size: 100,
      filterVariant: 'date',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
    {
      header: 'Action',
      size: 50,
      accessorFn: (row: { id: any; is_reply:any }) => <>
        <div className="btn-group action-btn-table">
          <ul style={{ listStyleType: "none", marginLeft: "-24px" }}>
            <span>
              <LinkButtons
                pageLink={`contact-us`}
                pageID={row?.id}
                showEdit={false}
                showView={true}
                showDelete={false}
              />
            </span>
          </ul>
          {row?.is_reply  == "0" ?   
          <ul  style={{ listStyleType: "none", paddingLeft: "0px" }}>
            <span onClick={() => handleOpen(row)} className="btn btn-primary me-2" >
              <i className="fas fa-reply"></i>
            </span>
          </ul>
          :<ul  style={{ listStyleType: "none", paddingLeft: "0px" }}>
          <span onClick={() => showPopu()} className="btn btn-primary me-2" >
            <i className="fas fa-reply"></i>
          </span>
        </ul>}
        </div>
      </>,
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      if (!data?.length) {
        setLoading(true);
      } else {
        setIsRefetching(true);
      }
      try {
        let query: any = paginationQuery(
          pagination.pageIndex,
          pagination.pageSize,
          sorting,
          searchValue,
          columnFilters
        );

        await dispatch(ContactlistGetAction(query));

      } catch (error) {
        setIsError(true);
        return;
      }
      setIsError(false);
      setLoading(false);
      setIsRefetching(false);
    };
    fetchData();
  }, [
    columnFilters,
    searchValue,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    Contact_Us_status?.status
  ]);
  useEffect(() => {
    setData(Contact_Us_Get?.data?.data?.rows);
    setRowCount(Contact_Us_Get?.data?.data?.count);
  }, [Contact_Us_Get?.data]);

  const handleClose = () => {
    setOpen(false)
    setReplymessage('')
    setError('')
    setOnedata('')
  }
  const handleSave = () => {
    const data = {
      reply_message: replymessage,
      id: onedata.id,
      is_reply: 1
    }
    if (replymessage == "" || replymessage == undefined || replymessage.trim() == "") {
      setError("Please Enter Reply Message")
    } else {
      dispatch(ContactStatusGetAction(data))
    }
  }
  useEffect(() => {
    if (Contact_Us_status?.data?.status) {
      setOpen(false)
      setReplymessage('')
      setOnedata({})
      setError('')
    }
  }, [Contact_Us_status?.data])
  const handeldate = (e: any) => {
    const formattedDate = moment(e).format('YYYY-MM-DD');
    setStartDate(formattedDate);
  }

  const handelEnddate = (e: any) => {
    const formattedDate = moment(e).format('YYYY-MM-DD');
    setEndDate(formattedDate)
  }
  const handleserach = (e: any) => {
    e.preventDefault()
    const columnFilters = [
      { id: "start_date", value: startDate.trim() },
      { id: "end_date", value: endDate.trim() },
      { id: "search", value: serachstatus?.namesearch?.trim() },
      { id: "user_type", value: serachstatus?.user },
      { id: "status", value: serachstatus?.replied }

    ]
    setColumnFilters(columnFilters)
    setOpenSerach(true)
  }
  const resetSearchfilter = () => {
    setOpenSerach(false)
    setStartDate('')
    setEndDate('')
    setSerachstatus('')
    if (formRef.current) {
      formRef.current.reset();
    }
    const columnFilters = [
      { id: "start_date", value: "" },
      { id: "end_date", value: "" },
      { id: "search", value: "" },
      { id: "category_id", value: "" },
      { id: "status", value: "" }

    ]
    setColumnFilters(columnFilters)

  }
  console.log(serachstatus)
  return (
    <Fragment>
      {(loading || Contact_Us_Get?.loading) ? <Spinner /> : ""}

      <PageLayout
        title="User Support Management"
        breadcrumbs={{
          secLast: { 'link': '/contact-us', 'name': 'User Support Management' },
        }}
        buttons={[
          { url: '/class-add', className: 'btn btn-primary', text: '+ Add Sponsors', show: false }, // This button will be shown
        ]}
      >
        <form ref={formRef} onSubmit={handleserach}>

          <div className='row gy-3 mt-3 mb-4'>
            <div className="col-md-4 col-lg-4 col-xl-3">
              <label>Start date</label>
              <DatePicker className="form-control" placeholderText='MM/DD/YYYY' value={startDate ? getDateFormatData(startDate) : ''} onChange={(e) => handeldate(e)} onKeyDown={(e) => e.preventDefault()} />
            </div>
            <div className="col-md-4 col-lg-4 col-xl-3">
              <label>End date</label>
              <DatePicker className="form-control" placeholderText='MM/DD/YYYY' value={endDate ? getDateFormatData(endDate) : ''} onChange={(e) => handelEnddate(e)} minDate={new Date(startDate)} onKeyDown={(e) => e.preventDefault()} />
            </div>
            <div className="col-md-4 col-lg-4 col-xl-3">
              <label>User type</label>
              <select className='form-select shadow-none' name="user" id="cars" onChange={handleFilterValue}>
                <option value="">All</option>
                <option value="Customer">Customer user </option>
                <option value="Salon">Salon user</option>
              </select>
            </div>
            <div className="col-md-4 col-lg-4 col-xl-3">
              <label>Replied Status</label>
              <select className='form-select shadow-none' name="replied" id="cars" onChange={handleFilterValue}>
                <option value="">All</option>
                <option value="1">Replied </option>
                <option value="0">Not replied</option>
              </select>
            </div>
            <div className="row gy-3">
              <div className='col-md-6 col-lg-4 col-xl-3'>
                <div className="input-group w-100">
                  <div className="input-group">
                    <span className="input-group-text fa-solid fa-magnifying-glass " id="basic-addon1"> <i className="fas fa-search"></i></span>
                    <input type='text' id="saerchId" name="namesearch" className="form-control m-0" placeholder='Search by name' onChange={handleFilterValue} />
                  </div>
                </div>
              </div>

              <div className="col-6">
                <button className='btn theme-bg text-white me-2'>Filter</button>
                <button className='btn btn-success' onClick={() => resetSearchfilter()} >Reset</button>
              </div>
            </div>
          </div>
        </form>
        {
          data &&
          <MaterialReactTable
            columns={columns}
            data={data}
            enableGlobalFilter={false}

            enableHiding={false}
            enableColumnFilters={false}
            enableDensityToggle={false}
            enableColumnActions={false}
            enableFullScreenToggle={false}
            positionToolbarAlertBanner="top"
            initialState={{ showColumnFilters: false }}
            manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={isError ? { color: 'error', children: 'Error loading data', } : undefined}
            muiSearchTextFieldProps={{
              placeholder: 'Search from name',
            }}
            onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={(value: any) => handleSearch(
              value,
              setIsError,
              setLoading,
              setIsRefetching,
              setSearchValue,
            )
            }
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={rowCount}
            state={{
              columnFilters,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
          />
        }

      </PageLayout>
      <Modal show={open} >
        <Modal.Header closeButton onClick={() => handleClose()}>
          <Modal.Title>Reply Message</Modal.Title>
        </Modal.Header>
        <div className="modal-body">
          <div className="row mb-3">
            <div className="col-12">
              <label className="form-label mb-0">Reply Message</label>
              <input type="text" maxLength={100} className="form-control" required onChange={(e) => setReplymessage(e.target.value)} />
              <span style={{ color: "red" }}>{error}</span>
            </div>
           
            {Contact_Us_status.loading ?  
            <div className="spinner-border text-warning" role="status">
                <span className="visually-hidden">Loading...</span>
           </div>
           :  <div className="col-12 mt-2">
           <a className="btn theme-bg float-start" style={{ color: "white" }} onClick={() => handleSave()} >SEND</a>
         </div>}
          </div>

        </div>
      </Modal>
    </Fragment>

  )
}

export default Contact;